import { ErrorHandler, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { createErrorHandler } from '@sentry/angular';

interface ErrorLike {
  name?: unknown;
  message?: unknown;
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private sentryErrorHandler: ErrorHandler;

  constructor(private swUpdate: SwUpdate) {
    this.sentryErrorHandler = createErrorHandler({
      showDialog: false
    })
  }

  handleError(error: unknown): void {
    if (isChunkLoadError(error)) {
      this.swUpdate.checkForUpdate().then(res => {
        if (res) window.location.reload()
      })
    } else {
      // Delegar a Sentry para manejar y registrar otros errores
      this.sentryErrorHandler.handleError(error)
    }
  }
}

function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const candidate = error as ErrorLike;
  const name = typeof candidate.name === 'string' ? candidate.name : '';
  const message = typeof candidate.message === 'string' ? candidate.message : '';
  return name === 'ChunkLoadError' || message.includes('Loading chunk');
}
